<template>
    <WarningBlock
        v-if="showFreePlanReportsLimitBlock"
        class="mt-6"
        :title="t('vue.free_plan_reports_limit_reached_header')"
        :description="
            t('vue.free_plan_reports_limit_reached_description', {
                date: freePlanResetDateLabel,
            })
        "
    >
        <template #actions>
            <AtomicButton
                color="yellow"
                size="md"
                class="h-8 shrink-0 px-4 text-[12px] font-semibold leading-4"
                @click="router.visit(route('billing.subscriptions.index'))"
            >
                {{ t("vue.free_plan_reports_limit_upgrade_button") }}
            </AtomicButton>
        </template>
    </WarningBlock>
</template>

<script setup lang="ts">
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import AtomicButton from "@/components/Atomic/Buttons/AtomicButton.vue";
import WarningBlock from "@/components/Atomic/Miscellaneous/WarningBlock.vue";
import { useTranslations } from "@/composables/useTranslations.ts";
import { useFreePlanMaxReachedPopup } from "@/composables/useFreePlanMaxReachedPopup";

const { t } = useTranslations();
const { showFreePlanReportsLimitBlock, freePlanResetDateLabel } =
    useFreePlanMaxReachedPopup();
</script>
